class PublicToiletLayer extends Layer {

  constructor(mapGL, isVisible = false) {
    super(mapGL, isVisible);

    this.name = 'publictoilet';
    this.minZoom = 9;
    this.layerIds = ['publictoilet'];

    this.isClickable = true;

    this.load();
  }

  load() {

    this.mapGL.getMapObject().addSource(this.name + '-source', {
      'type': 'geojson',
      'data': CACHE_URL + '/getLayer?action=load&layer=publicToilet'
    });

    this.mapGL.getMapObject().addLayer({
      'id': this.layerIds[0],
      'type': 'symbol',
      'source': this.name + '-source',
      'layout': {
        'icon-image': this.name,
        'icon-allow-overlap': true,
        'visibility': this.isVisible ? 'visible' : 'none'
      },
      'minzoom': this.minZoom,
    });

    var thisLayer = this;

    this.mapGL.getMapObject().on('click', this.layerIds[0], function (e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var popupContent = thisLayer.getPopupContent(e.features[0]);

      if (thisLayer.mapGL.popup.isOpen()) {
        thisLayer.mapGL.popup.remove();
      }

      thisLayer.mapGL.popup = new maplibregl.Popup({focusAfterOpen: false})
        .setLngLat(coordinates)
        .setHTML(popupContent)
        .setMaxWidth("none")
        .addTo(thisLayer.mapGL.getMapObject());
    });

    if (!Utils.isMobileOrTablet()) {
      this.mapGL.getMapObject().on('mouseenter', this.layerIds[0], function (e) {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = 'pointer';
        var coordinates = e.features[0].geometry.coordinates.slice();
        var tooltipContent = thisLayer.getTooltipContent(e.features[0]);

        if (thisLayer.mapGL.tooltip.isOpen()) {
          thisLayer.mapGL.tooltip.remove();
        }

        thisLayer.mapGL.tooltip.setLngLat(coordinates)
          .setHTML(tooltipContent)
          .addTo(thisLayer.mapGL.getMapObject());
      });

      this.mapGL.getMapObject().on('mousemove', this.layerIds[0], function (e) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        var tooltipContent = thisLayer.getTooltipContent(e.features[0]);
        thisLayer.mapGL.tooltip.setLngLat(coordinates).setHTML(tooltipContent);
        if (!thisLayer.mapGL.tooltip.isOpen()) {
          thisLayer.mapGL.tooltip.addTo(thisLayer.mapGL.getMapObject());
        }
      });

      this.mapGL.getMapObject().on('mouseleave', this.layerIds[0], function () {
        thisLayer.mapGL.getMapObject().getCanvas().style.cursor = '';
        thisLayer.mapGL.tooltip.remove();
      });
    }
  }

  getTooltipContent(feature) {
    var tooltipContent = '<div class="map-tooltip">' + feature.properties.adresse + '</div>';
    return tooltipContent;
  }

  getPopupContent(feature) {

    var popupContent = '<div class="map-popup">';
    popupContent += '<img class="map-popup__icon" src="' + IMG_PATH + '/Unsprited/mapicons/publictoilet.svg" alt="" aria-hidden="true">';

    if (feature.properties.voie !== null) {
      popupContent += '<span class="map-popup__title">' + feature.properties.adresse + '</span>';
      popupContent += '<hr>';
    }

    if (feature.properties.commune !== null) {
      popupContent += '<span class="map-popup__commune">' + feature.properties.commune + '</span>';
    }

    if (feature.properties.infoloc !== null) {
      popupContent += '<br>';
      popupContent += '<span class="map-popup__infoloc">' + feature.properties.infoloc + '</span>';
    }

    popupContent += JourneyPlanner.getPopupContentActions(feature._geometry.coordinates, feature.properties.adresse);
    popupContent += '</div>';

    return popupContent;
  }
}
